module.exports = __webpack_public_path__ + "img/icon-warning-avalanches-orange.211dba75.svg";